import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { color } from "framer-motion";

export default function ValidStudent() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let id;
    try {
      //id = atob(token);
      id = token;
    } catch (e) {
      setLoading(false);
      return;
    }

    axios
      .get("https://dgps.co.in/api/verify-teacher", {
        params: { id }
      })
      .then(res => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [token]);

  /* ---------------- STATES ---------------- */

  if (loading) {
    return (
      <div style={styles.center}>
        <p>🔍 Verifying teacher...</p>
      </div>
    );
  }

  if (!data?.success) {
    return (
      <div style={styles.center}>
        <h3 style={{ color: "#c62828" }}>❌ Invalid QR Code</h3>
        <p>This teacher record was not found.</p>
      </div>
    );
  }

  const { teacher, school } = data;

  const schoolLogo =
    "https://dgps.co.in/public/admin/assets/img/schools/logo/" +
    school.logo;

  /* ---------------- UI ---------------- */

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* SCHOOL HEADER */}
        <div style={styles.header}>
          <img src={schoolLogo} alt="School Logo" style={styles.logo} />
          <h2 style={styles.schoolName}>{school.name}</h2>
          <p style={styles.schoolAddress}>{school.address}</p>
        </div>

        {/* TEACHER INFO */}
        <div style={styles.body}>
          <img
            src={`https://dgps.co.in/${teacher.photo}`}
            alt="Teacher"
            style={styles.teacherPhoto}
          />

          <h3 style={styles.teacherName}>{teacher.name}</h3>

          <div style={styles.badge}>✅ Valid Teacher</div>

          <div style={styles.table}>
            <Row label="Department" value={teacher.department} />
            <Row
              label="Qualification"
              value={teacher.qualification}
            />
            <Row label="Gender" value={teacher.gender} />
            <Row label="Blood Group" value={teacher.blood} />
            <Row label="Father" value={teacher.father_name} />
          </div>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <p style={styles.footerText}>
            This is a digitally verified teacher record.
          </p>
          <p style={styles.footerSmall}>
            Powered by RightEn School Management System
          </p>
        </div>
      </div>
    </div>
  );
}

/* ---------------- COMPONENT ---------------- */

const Row = ({ label, value }) => (
  <div style={styles.row}>
    <span style={styles.label}>{label}</span>
    <span style={styles.value}>{value}</span>
  </div>
);

/* ---------------- STYLES ---------------- */

const styles = {
  page: {
    minHeight: "100vh",
    background: "#eef2f7",
    padding: "15px",
    fontFamily: "Arial, sans-serif"
  },

  center: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    fontFamily: "Arial"
  },

  card: {
    maxWidth: "420px",
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 8px 25px rgba(0,0,0,0.1)"
  },

  header: {
    background: "#0f3b66",
    color: "#fff",
    padding: "20px",
    textAlign: "center"
  },

  logo: {
    height: "70px",
    marginBottom: "10px"
  },

  schoolName: {
    margin: "5px 0",
    color: "#fff",
    fontSize: "18px"
  },

  schoolAddress: {
    fontSize: "12px",
    opacity: 0.9
  },

  body: {
    padding: "20px",
    textAlign: "center"
  },

  teacherPhoto: {
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #0f3b66",
    marginBottom: "10px"
  },

  teacherName: {
    margin: "8px 0",
    fontSize: "20px",
    color: "#0f3b66"
  },

  badge: {
    display: "inline-block",
    background: "#2e7d32",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "13px",
    marginBottom: "15px"
  },

  table: {
    marginTop: "10px",
    textAlign: "left"
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    borderBottom: "1px solid #eee",
    fontSize: "14px"
  },

  label: {
    color: "#555"
  },

  value: {
    fontWeight: "bold",
    color: "#000"
  },

  footer: {
    background: "#f5f7fa",
    padding: "15px",
    textAlign: "center"
  },

  footerText: {
    fontSize: "13px",
    marginBottom: "5px"
  },

  footerSmall: {
    fontSize: "11px",
    color: "#777"
  }
};
